import React from 'react';
import { injectIntl, WrappedComponentProps } from '@kyruus/intl';
import { ExtendedProvider } from 'Src/types';
import { CtaListItem, ListItemButtonProps } from './CtaListItem';
import { DefaultCtaListItems, messages } from '../../lib';

interface BaseVirtualCareProps {
  provider: ExtendedProvider;
  trackListItemClick: (listItem: DefaultCtaListItems) => void;
}
type VirtualCareProps = BaseVirtualCareProps & WrappedComponentProps;

export const VirtualCare = injectIntl(
  ({ provider, intl, trackListItemClick }: VirtualCareProps) => {
    const primaryText = intl.formatMessage(messages.virtualCareTitle);
    const secondaryText =
      intl.formatMessage(messages.virtualCareSubtitle) === ' '
        ? undefined
        : intl.formatMessage(messages.virtualCareSubtitle);

    const buttonProps: ListItemButtonProps = {
      component: 'a',
      href: provider.virtual_care_url ?? undefined,
      role: 'link',
      target: '_blank',
      rel: 'noopener noreferrer',
      onClick: () => trackListItemClick(DefaultCtaListItems.VirtualCare)
    };
    return (
      <CtaListItem
        buttonProps={buttonProps}
        primaryText={primaryText}
        secondaryText={secondaryText}
        isExternalLink={true}
      />
    );
  }
);
